import { useState } from 'react'

const navLinks = [
  { name: 'Inicio', href: '#hero' },
  { name: 'Funcionalidades', href: '#features' },
  { name: 'Proceso', href: '#howitworks' },
  { name: 'Precios', href: '#pricing' },
  { name: 'Testimonios', href: '#testimonials' },
  { name: 'Contacto', href: '#contact' }
]

export function Header() {
  const [menuOpen, setMenuOpen] = useState(false)

  return (
    <header className="fixed top-0 left-0 w-full z-50 backdrop-blur bg-gray-950/80 border-b border-gray-900/40 shadow-sm">
      <nav className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4 lg:px-8" aria-label="Main navigation">
        {/* Logo */}
        <a href="#hero" className="flex items-center gap-2 text-white font-bold text-xl">
          <svg className="h-7 w-7 text-primary-500" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="16" cy="16" r="16" fill="currentColor" />
            <path d="M10 17l4-4 4 4 4-4" stroke="#6366F1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
          Validea
        </a>

        {/* Desktop nav */}
        <div className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <a
              key={link.name}
              href={link.href}
              className="text-sm font-medium text-gray-200 hover:text-primary-400 transition-colors duration-200"
            >
              {link.name}
            </a>
          ))}
        </div>

        {/* Desktop auth buttons */}
        <div className="hidden md:flex items-center gap-3">
          <a
            href="/login"
            className="rounded-full bg-primary-600 px-5 py-2 text-sm font-semibold text-white shadow-lg hover:bg-primary-500 transition-colors"
          >
            Iniciar sesión
          </a>
          <a
            href="/register"
            className="rounded-full border border-white px-5 py-2 text-sm font-semibold text-white bg-transparent hover:bg-white hover:text-primary-600 hover:border-white transition-colors"
          >
            Registrarse
          </a>
        </div>

        {/* Mobile menu button */}
        <button
          className="md:hidden flex items-center justify-center rounded-full p-2 text-gray-200 hover:bg-gray-900/40 focus:outline-none"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Abrir menú"
        >
          <svg className="h-6 w-6" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
            {menuOpen ? (
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
            ) : (
              <path strokeLinecap="round" strokeLinejoin="round" d="M4 8h16M4 16h16" />
            )}
          </svg>
        </button>
      </nav>

      {/* Mobile menu */}
      {menuOpen && (
        <div className="md:hidden bg-gray-950/95 backdrop-blur border-t border-gray-900/40 px-6 pb-6 pt-2">
          <div className="flex flex-col gap-4">
            {navLinks.map((link) => (
              <a
                key={link.name}
                href={link.href}
                className="text-base font-medium text-gray-200 hover:text-primary-400 transition-colors duration-200"
                onClick={() => setMenuOpen(false)}
              >
                {link.name}
              </a>
            ))}
            <a
              href="/login"
              className="mt-2 rounded-full bg-primary-600 px-5 py-2 text-sm font-semibold text-white shadow-lg hover:bg-primary-500 transition-colors text-center"
              onClick={() => setMenuOpen(false)}
            >
              Iniciar sesión
            </a>
            <a
              href="/register"
              className="rounded-full border border-white px-5 py-2 text-sm font-semibold text-white bg-transparent hover:bg-white hover:text-primary-600 hover:border-white transition-colors text-center"
              onClick={() => setMenuOpen(false)}
            >
              Registrarse
            </a>
          </div>
        </div>
      )}
    </header>
  )
} 